import { render, staticRenderFns } from "./Wishlist_Priority.vue?vue&type=template&id=3d534398"
import script from "./Wishlist_Priority.vue?vue&type=script&lang=js"
export * from "./Wishlist_Priority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports